import { Navigate, generatePath } from 'react-router-dom';

import {
  MLB_PLAY_EVENTTYPE,
  MLB_PLAY_LINEUPS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { useLastVisitedEventType } from '@sorare/gameplay/src/hooks/useLastVisitedEventType';

export const MLBPlayPage = () => {
  const {
    flags: { useMlbNewPlayPage = false },
  } = useFeatureFlags();
  const { lastVisitedEventType } = useLastVisitedEventType();

  if (useMlbNewPlayPage) {
    return (
      <Navigate
        to={generatePath(MLB_PLAY_EVENTTYPE, {
          eventType: lastVisitedEventType,
        })}
        replace
      />
    );
  }
  return <Navigate to={MLB_PLAY_LINEUPS} replace />;
};

export default MLBPlayPage;
